export const FETCH_CITIES_START = "FETCH_CITIES_START";
export const FETCH_CITIES_SUCCESS = "FETCH_CITIES_SUCCESS";
export const FETCH_CITIES_FAIL = "FETCH_CITIES_FAIL";

export const FETCH_CITY_BY_ID_START = "FETCH_CITY_BY_ID_START";
export const FETCH_CITY_BY_ID_SUCCESS = "FETCH_CITY_BY_ID_SUCCESS";
export const FETCH_CITY_BY_ID_FAIL = "FETCH_CITY_BY_ID_FAIL";
